// node.js independent path helpers
const normalize = (path: string) => {
  return path.replaceAll(/\/\/+/g, '/')
}

export const join = (base: string, path: string): string => {
  return normalize(base + '/' + path)
}

export const relative = (base: string, path: string): string => {
  if (path.startsWith(base)) {
    return normalize(path.substring(base.length))
  }
  return base
}
